// extracted by mini-css-extract-plugin
export default {"back":"Back_back__LoTLr","text":"Back_text__2y7l8"};